import { DiscoveryDocument } from 'phoenix/domain';

export type IDiscoveryDocumentService = DiscoveryDocumentService;

/**
 * A simple service for retrieving the discovery document.
 */
export class DiscoveryDocumentService {
    public static readonly $inject = [
        '$http',
        '$q',
        'pxUriPathService'
    ];

    private discoveryDocument: DiscoveryDocument | null = null;

    constructor(
        private readonly $http: ng.IHttpService,
        private readonly $q: ng.IQService,
        private readonly uri: { resolvePath: (path: string) => string; }
    ) {
    }

    /**
     * Gets and caches the discovery document
     * 
     * @returns A promise that will resolve with the discovery document.
     */
    public get(): ng.IPromise<DiscoveryDocument> {
        let p: ng.IPromise<DiscoveryDocument>;

        if (this.discoveryDocument === null) {
            let url = this.uri.resolvePath('/discovery');
            p = this.$http.get(url)
                .then((res) => res.data)
                .then((doc: DiscoveryDocument) => {
                    if (!(doc.PushServer && doc.PushServer.Url)) {
                        doc.PushServer = {
                            Url: '',
                            Path: ''
                        };
                    } else {
                        // Only cache when doc is valid
                        this.discoveryDocument = doc;
                    }

                    return doc;
                })
                .catch(() => ({
                    // If discovery endpoint cant be accessed, the app does not know how
                    // to access the push server, just disable for any errors.
                    PushServer: {
                        Url: '',
                        Path: ''
                    }
                }));
        } else {
            p = this.$q.resolve(this.discoveryDocument);
        }

        return p;
    }
}


// WEBPACK FOOTER //
// ./src/phoenix/services/discoveryDocumentService.ts